import { useEffect, useState } from 'react';
import Cards from "./Cards";
import { useHistory } from "react-router-dom";
const API_KEY = "f7cb3a66b84cc5a6c86ec358b6f7af76";
export default function App(props) {
    let [page,setPage] = useState(1);
    const URL = 'https://api.themoviedb.org/3/movie/now_playing?api_key=' + API_KEY + '&language=en-US&page='+page;

    let [loading, setLoading] = useState(true);
    let [data, setData] = useState([]);
    
    let history = useHistory();
    let getData = async () => {
        let data = await (await fetch(URL)).json();
        console.log(data);
        setData(data.results);
        setLoading(false);
    }

    useEffect(() => {
        getData();
        // eslint-disable-next-line
    }, [page]);

    let goToSelected = (id) => {
        history.push({
            pathname: "/selected/"+id,
            state: { 
                id: id
            }
        });
    }
    return (
        <div className="container">
            {loading && (
                <h1 className="loading">Loading...</h1>)
            }

            <div className="movie-container">
                {
                    data.map(e =>
                        <Cards key={e.id} movieName={e.title} movieId={e.id} selectedPage={goToSelected} picture={"http://image.tmdb.org/t/p/w500/" + e.poster_path} desc={e.overview} />
                    )
                }
            </div>
            <button className="hidden" onClick={()=>setPage(page+1)}> Next page </button>
        </div>
    )
}